import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { articles, hotTags } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function HeroSearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category/remenzixun?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[480px] md:min-h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20geometric%20shapes%2C%20golden%20orange%20and%20cream%20tones%2C%20minimal%20modern%20design%2C%20smooth%20textures%2C%20clean%20atmosphere%2C%20no%20text&width=1920&height=900&seq=hero-bg-51nav&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 font-heading">
          51网址导航
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-lg">
          上网从这里开始 — 网址导航123快捷入口，热门资讯一网打尽
        </p>

        <form onSubmit={handleSearch} className="w-full max-w-xl flex items-center gap-0">
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索网站、资讯、吃瓜事件..."
              className="w-full h-12 pl-11 pr-4 bg-white rounded-l-full text-sm text-foreground-900 placeholder-foreground-400 outline-none border-0"
            />
          </div>
          <button
            type="submit"
            className="h-12 px-6 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-r-full transition-colors whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
          <span className="text-xs text-white/60 whitespace-nowrap">热门搜索：</span>
          {hotTags.slice(0, 6).map((tag) => (
            <button
              key={tag}
              onClick={() => {
                setSearchQuery(tag);
                navigate(`/category/remenzixun?q=${encodeURIComponent(tag)}`);
              }}
              className="px-3 py-1 bg-white/15 hover:bg-white/25 text-white text-xs rounded-full transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}